<app-menu></app-menu>

<div style="background-color: #ffffff;">
    <div class="fundo-sobre uk-light">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">Private Cloud
            </h1>
            <p class="uk-text-large" style="opacity: 0.9;"
                uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">Infraestrutura de Nuvem Privada para
                Empresas</p>
        </div>
    </div>
</div>

<!-- Intro Section -->
<div class="uk-section uk-section-muted">
    <div class="uk-container">
        <div class="uk-grid uk-grid-match" uk-grid>
            <!-- Content Card (Left) -->
            <div class="uk-width-2-3@m" uk-scrollspy="cls: uk-animation-slide-left-small; delay: 100">
                <div class="about-card uk-height-1-1">
                    <h2 class="mission-header title-highlight">Nuvem Dedicada & Exclusiva</h2>
                    <div class="section-content">
                        <p>
                            O nosso serviço de <strong>Private Cloud</strong> oferece a criação, gestão e manutenção de
                            ambientes de nuvem dedicados, projetados especificamente para atender às necessidades da sua
                            empresa.
                        </p>
                        <div class="quote-box">
                            Diferente das soluções públicas, a nuvem privada garante maior controlo, segurança e
                            desempenho, permitindo que os seus dados e aplicações operem num ambiente exclusivo.
                        </div>
                        <p>
                            Desenvolvemos infraestruturas robustas e escaláveis, ideais para empresas que necessitam de
                            alto nível de personalização, conformidade e proteção de dados. Desde a configuração inicial
                            até à monitorização contínua, asseguramos uma solução estável, segura e otimizada.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Highlights (Right) -->
            <div class="uk-width-1-3@m" uk-scrollspy="cls: uk-animation-slide-right-small; delay: 200">
                <div class="uk-flex uk-flex-column uk-height-1-1">
                    <div class="milestone-card">
                        <span class="milestone-year"><i class="fa-solid fa-shield-halved fa-lg"></i></span>
                        <h4 class="uk-margin-remove" style="color: white; font-weight: 700;">Segurança Avançada</h4>
                        <p style="opacity: 0.8; font-size: 0.9rem; margin: 5px 0 0 0;">
                            Controlo total dos dados e conformidade estrita.
                        </p>
                    </div>

                    <div class="milestone-card" uk-scrollspy="cls: uk-animation-slide-right-small; delay: 400">
                        <span class="milestone-year"><i class="fa-solid fa-bolt-lightning fa-lg"></i></span>
                        <h4 class="uk-margin-remove" style="color: white; font-weight: 700;">Alto Desempenho</h4>
                        <p style="opacity: 0.8; font-size: 0.9rem; margin: 5px 0 0 0;">
                            Baixa latência e recursos dedicados sem partilha.
                        </p>
                    </div>

                    <div class="milestone-card" uk-scrollspy="cls: uk-animation-slide-right-small; delay: 600">
                        <span class="milestone-year"><i class="fa-solid fa-chart-line fa-lg"></i></span>
                        <h4 class="uk-margin-remove" style="color: white; font-weight: 700;">Escalabilidade</h4>
                        <p style="opacity: 0.8; font-size: 0.9rem; margin: 5px 0 0 0;">
                            Recursos que crescem conforme o seu negócio.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- What we include Section (Premium Card Style) -->
<div class="uk-section uk-section-muted">
    <div class="uk-container">
        <div class="email-corp-card" uk-scrollspy="cls: uk-animation-scale-up; delay: 100">
            <div class="uk-grid uk-grid-large uk-grid-divider uk-child-width-1-2@m uk-flex-middle" uk-grid>
                <!-- Lado Esquerdo: Título e Branding -->
                <div class="uk-text-center uk-text-left@m">
                    <h2 class="email-title">O que<br>incluímos</h2>
                    <div class="webmail-branding">
                        <i class="fa-solid fa-layer-group branding-icon"></i>
                        <span class="webmail-text">SOLUÇÃO <b>END-TO-END</b></span>
                    </div>
                </div>

                <!-- Lado Direito: Lista de Recursos -->
                <div>
                    <div class="description-box">
                        <h4 class="uk-text-bold highlight-text" style="font-weight: 800; letter-spacing: 1px;">Tecnologia de Ponta</h4>
                        <p class="uk-text-lead">
                            Integramos as melhores ferramentas de gestão e segurança para a sua infraestrutura.
                        </p>
                        <p style="color: #666; font-size: 1.05rem; line-height: 1.5;">
                            Nossa solução oferece automação completa, proteção avançada e alta disponibilidade para seus sistemas críticos.
                        </p>
                        <ul class="uk-list feature-list">
                            <li><i class="fa-solid fa-server uk-margin-small-right highlight-text"></i> <b>Servidores Virtuais:</b> Instâncias Dedicadas</li>
                            <li><i class="fa-solid fa-gears uk-margin-small-right highlight-text"></i> <b>Redes e Segurança:</b> Firewalls & vLANs</li>
                            <li><i class="fa-solid fa-clock-rotate-left uk-margin-small-right highlight-text"></i> <b>Backup e DR:</b> Proteção Contínua</li>
                            <li><i class="fa-solid fa-headset uk-margin-small-right highlight-text"></i> <b>Suporte 24/7:</b> Engenheiros Nível 3</li>
                            <li><i class="fa-solid fa-star uk-margin-small-right highlight-text"></i> <b>Personalização:</b> Hardware sob Medida</li>
                            <li><i class="fa-solid fa-microchip uk-margin-small-right highlight-text"></i> <b>Monitorização:</b> Alertas em Tempo Real</li>
                        </ul>
                        <div class="uk-margin-medium-top">
                            <a href="https://wa.me/244937754502/?text=Olá, desejo saber mais sobre o que está incluído no Private Cloud." 
                               target="_blank" class="uk-button btn-buy">
                                SABER MAIS
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Final CTA Section -->
<div class="cta-section uk-section">
    <div class="uk-container uk-text-center">
        <div class="premium-cta-box" uk-scrollspy="cls: uk-animation-scale-up">
            <div class="cta-glow"></div>
            <div class="light-particles">
                <div class="particle p1"></div>
                <div class="particle p2"></div>
                <div class="particle p3"></div>
                <div class="particle p4"></div>
                <div class="particle p5"></div>
                <div class="particle p6"></div>
                <div class="particle p7"></div>
                <div class="particle p8"></div>
                <div class="particle p9"></div>
                <div class="particle p10"></div>
            </div>
            <div class="cta-content">
                <h2>Construa a sua cloud privada</h2>
                <p>Ideal para empresas que procuram autonomia, confiabilidade e performance, o Private Cloud é a base
                    perfeita para suportar sistemas críticos e crescimento sustentável.</p>
                <a href="https://wa.me/244937754502/?text=Olá, estou interessado no serviço de Private Cloud. Gostaria de uma consultoria."
                    target="_blank" class="uk-button uk-button-default cta-btn">
                    <i class="fa-solid fa-headset uk-margin-small-right"></i> Fale com Especialistas
                </a>
            </div>
        </div>
    </div>
</div>

<app-rodape></app-rodape>